// src/components/GuestRoute.js
import React from 'react';
import { Navigate } from 'react-router-dom';

const GuestRoute = ({ children }) => {
  const token = sessionStorage.getItem('token');
  return token ? <Navigate to="/dashboard" replace /> : children;
};

export default GuestRoute;
